<template>
  <div class="container">
    <div class="upload-container">
      <div class="margin-bottom-1">
        <span class="black-bold"
          >Pictures inserted from here will appear in the slideshow of your
          College Profile Summary</span
        >
      </div>
      <BaseDragUpload
        :upload-limit="3"
        multiple
        ref="imageUpload"
        @file-upload="handleMultipleUpload"
        @file-delete="handleFileDelete"
        :preview-images="college.background"
      />
      <a-button
        :disabled="_.isEmpty(this.imageArray)"
        class="margin-bottom-1 btn btn-default height-3rem"
        @click="handleButtonClick"
        :loading="collegeImageUploadLoading"
      >
        Upload
      </a-button>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

const COLLEGE_STORE_KEY = "collegeStore";

export default {
  mounted() {
    this.getCollege();
  },
  computed: {
    ...mapGetters({
      college: `${COLLEGE_STORE_KEY}/college`,
      collegeImageUploadLoading: `${COLLEGE_STORE_KEY}/collegeImageUploadLoading`
    })
  },
  data() {
    return {
      imageArray: []
    };
  },
  methods: {
    handleMultipleUpload(data) {
      this.imageArray = data;
    },
    async handleButtonClick() {
      let images = new FormData();
      this.imageArray.forEach((item, index) =>
        images.append(`file${index}`, item)
      );
      await this.$store.dispatch(`${COLLEGE_STORE_KEY}/uploadCollegeImages`, {
        id: localStorage["college-id"],
        images
      });
      this.getCollege();
      this.$refs.imageUpload.handleClearAll();
    },
    getCollege() {
      this.$store.dispatch(`${COLLEGE_STORE_KEY}/getCollege`, {
        id: localStorage["college-id"]
      });
    },
    handleFileDelete(data) {
      this.$store.dispatch(`${COLLEGE_STORE_KEY}/deleteCollegeImages`, {
        id: localStorage["college-id"],
        data: data
      });
    }
  }
};
</script>

<style lang="sass">
.upload-container
</style>
